var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHashtag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49643 10.5795H2V9.11696H4.71071L5.06161 6.88571H2.40179V5.42321H5.27321L5.85714 2H7.56875L6.98482 5.42054H9.81339L10.3973 2H12.0875L11.5036 5.42054H14V6.88304H11.2705L10.9411 9.11429H13.5982V10.5768H10.7455L10.1429 14H8.45268L9.03661 10.5795H6.18661L5.60268 14H3.9125L4.49643 10.5795ZM6.75179 6.88304L6.41964 9.11696H9.24821L9.57768 6.88571H6.75179V6.88304Z",
    fill: "#3F8CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtag);
export default __webpack_public_path__ + "static/media/hashtag.d7a8b6057ac01cdc89710cacb569da42.svg";
export { ForwardRef as ReactComponent };